import { useLayoutEffect, useRef } from "react";

const main = () => document.querySelector<HTMLElement>(".pn-app > .pn-main");

/**
 * A screen pushed on top of its parent through the address's query (one ad over Ads, the emails over Getting
 * ready). Why: the frame keeps each screen's place by its path, and a query keeps the path, so the pushed
 * screen opens at its top and going back returns the parent to where it was left.
 */
export function useSubScreen(key: string | null): void {
  const parentAt = useRef(0);
  const last = useRef<string | null>(key);
  useLayoutEffect(() => {
    const el = main();
    if (!el || last.current === key) return;
    if (last.current === null) parentAt.current = el.scrollTop;
    el.scrollTop = key === null ? parentAt.current : 0;
    last.current = key;
  }, [key]);
}
